export enum AppVersionActionTypes {
    API_RESPONSE_SUCCESS = '@@appVersions/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@appVersions/API_RESPONSE_ERROR',

    GET_APP_VERSIONS = '@@appVersions/GET_APP_VERSIONS',
    GET_APP_VERSION_BY_ID = '@@appVersions/GET_APP_VERSION_BY_ID',
    CREATE_APP_VERSION = '@@appVersions/CREATE_APP_VERSION',
    UPDATE_APP_VERSION = '@@appVersions/UPDATE_APP_VERSION',
    DELETE_APP_VERSION = '@@appVersions/DELETE_APP_VERSION',

    RESET = '@@appVersions/RESET',
}
